import { Avatar, Card, CardHeader, Tooltip, Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useCallback, useRef, useState } from "react"
import styles from "./Post.module.css"
import { useUser } from "../hooks/Contexts/UserContext/UserContext"
import Icn from "../UI/SharieIcn/SharieIcn"
import NewSkillModal from "../Modals/NewSkillModal/NewSkillModal"
import AIModal from "../Modals/AIModal/AIModal"
import T from "../hooks/Language/T"
import useTranslationSharie from "../hooks/Language/useTranslation"
import AddIcon from "@mui/icons-material/Add"
import NewDemandModal from "../Modals/NewDemandModal/NewDemandModal"
import Sphere from "../UI/Sphere"
import handslogo from "../../assets/images/shariehandslogo.png"
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates"
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate"
import WisdomModal from "../Modals/WisdomModal/WisdomModal"
import useDeviceType from "../hooks/Utils/useDeviceType"

const Post = () => {
  const [upload, setUpload] = useState(false)
  const { context_user } = useUser()
  const skillRef = useRef()
  const aiRef = useRef()
  const demandRef = useRef()
  const wisdomRef = useRef()
  const deviceType = useDeviceType()
  const isDesktop = deviceType === "desktop"
  const navigate = useNavigate()
  const t = useTranslationSharie()

  const handleAvatarClick = () => {
    navigate("/profile", {
      state: { user_name: localStorage.getItem("user"), editable: true },
    })
  }
  const openNewSkillModalForUpload = useCallback(() => {
    setUpload(true)
    setTimeout(() => {
      setUpload(false)
    }, 2500)
    if (skillRef.current) {
      skillRef.current.childFunction()
    }
  }, [])
  const openNewSkillModal = useCallback(() => {
    if (skillRef.current) {
      skillRef.current.childFunction()
    }
  }, [])

  const openAIModal = useCallback(() => {
    if (aiRef.current) {
      aiRef.current.childFunction()
    }
  }, [])
  const handleWisdomClick = () => {
    if (wisdomRef.current) {
      wisdomRef.current.childFunction()
    }
  }
  const openDemandModal = useCallback(() => {
    if (demandRef.current) {
      demandRef.current.childFunction()
    }
  }, [])
  return (
    <T>
      <div className={styles.posts_container}>
        <NewSkillModal ref={skillRef} upload={upload} />
        <AIModal ref={aiRef} />
        <NewDemandModal ref={demandRef} />
        <WisdomModal ref={wisdomRef} />
        <Card className={styles.container_card}>
          <Card className={styles.posts_card}>
            <Icn
              className={"post_avatar"}
              tooltip={"View Profile"}
              onClick={handleAvatarClick}
              avatar={<Avatar src={context_user?.image} style={{ marginInlineStart: "1rem" }} />}
            />

            <Tooltip title={t("Start A Post")}>
              <div className={styles.posts_fakeinput} onClick={openNewSkillModal}>
                Post A Skill ...{" "}
              </div>
            </Tooltip>

            <Icn
              color='#1976d2'
              tooltip='Learn with AI'
              onClick={openAIModal}
              icon={<Sphere image={handslogo} />}
            />
          </Card>
          <Card className={styles.icons_card}>
            <div className={styles.icons_container} onClick={openDemandModal}>
              <Icn color='#1976d2' tooltip='Post Demand' icon={<AddIcon fontSize='medium' />} />
              {isDesktop && (
                <Typography variant='button' color='gray'>
                  Demand
                </Typography>
              )}
            </div>
            <div className={styles.icons_container} onClick={handleWisdomClick}>
              <Icn
                color='#9c27b0'
                tooltip='Post Reflection'
                icon={<TipsAndUpdatesIcon fontSize='medium' />}
              />
              {isDesktop && (
                <Typography variant='button' color='gray'>
                  Reflection
                </Typography>
              )}
            </div>
            <div className={styles.icons_container} onClick={openNewSkillModalForUpload}>
              <Icn
                color='gold'
                tooltip='Upload Image/Video'
                icon={<AddPhotoAlternateIcon fontSize='medium' />}
              />
              {isDesktop && (
                <Typography variant='button' color='gray'>
                  Upload Image/Video
                </Typography>
              )}
            </div>
          </Card>
        </Card>
        {/* <Card className={styles.background_card}>
          <Button className={styles.ai_button} onClick={openAIModal}>
            Learn with AI
          </Button>
        </Card> */}
      </div>
    </T>
  )
}

export default Post
